'use client';

import Link from "next/link";
import { useState, useEffect } from 'react';
import { useTranslations } from "next-intl";
import { usePathname } from "next/navigation";

export default function News() {
  const pathname = usePathname();
  const currentLocale = pathname.match(/^\/([a-z]{2}-[A-Z]{2})/)?.[1] || 'zh-CN';
  const t = useTranslations('news');
  const [news, setNews] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await fetch('/api/news');
        if (!response.ok) {
          throw new Error('Failed to fetch news');
        }
        const data = await response.json();
        setNews(data);
      } catch (err) {
        setError('获取新闻数据失败');
        console.error('Error fetching news:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  return (
    <div>
      {/* 页面标题 */}
      <section className="bg-gray-100 py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold text-center text-black">{t('title')}</h1>
          <p className="text-center text-black mt-4">{t('description')}</p>
        </div>
      </section>

      {/* 新闻列表 */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 p-4 rounded-lg mb-8 text-center">
              {error}
            </div>
          )}
          
          {loading ? (
            <div className="flex justify-center items-center py-20">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
            </div>
          ) : news.length === 0 ? (
            <div className="text-center py-20">
              <p className="text-xl text-gray-600">{t('noNews')}</p>
            </div>
          ) : (
            <div className="space-y-8">
              {news.map((item) => (
                <div key={item.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
                  <div className="p-6">
                    <div className="flex flex-col md:flex-row md:items-center justify-between mb-4">
                      <h3 className="text-2xl font-semibold mb-2 md:mb-0">{item.title}</h3>
                      <span className="text-gray-600 text-sm">{t('publishDate')}: {new Date(item.createdAt).toLocaleDateString()}</span>
                    </div>
                    <p className="text-black mb-6">{item.content.substring(0, 200)}...</p>
                    <Link href={`/${currentLocale}/news/${item.id}`} className="inline-block text-blue-600 font-medium hover:underline">
                      {t('readMore')} →
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* 订阅新闻 */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="bg-blue-600 rounded-lg shadow-lg p-8 text-white text-center">
            <h2 className="text-3xl font-bold mb-4">{t('title')}</h2>
            <p className="text-xl mb-8">{t('description')}</p>
            <div className="max-w-md mx-auto flex">
              <input 
                type="email" 
                placeholder="Email" 
                className="flex-1 px-4 py-3 rounded-l-lg focus:outline-none text-black"
              />
              <button className="bg-white text-blue-600 px-6 py-3 rounded-r-lg font-medium hover:bg-gray-100 transition-colors">
                {t('readMore')}
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}